import { useMutation, useQueryClient } from '@tanstack/react-query'
import { completeOnboarding } from '../api/onboardingApi'
import { employeeKeys } from '@/entities/employee/model/queries'

export function useCompleteOnboarding() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => completeOnboarding(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: employeeKeys.currentUser() })
    },
  })
}
